import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

export const StyledNavigationContainer = styled.aside`
  padding: 1.1rem 3rem 0 0;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.background.light};
  border-radius: ${({ theme }) => theme.radius.small};
  position: relative;
  box-shadow: ${({ theme }) => theme.boxShadow.light};
`;

export const StyledOption = styled.button<{ isSelected: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 0.8rem;
  padding: 0.9rem 0rem 0.9rem 1.4rem;
  margin-left: 2.7rem;
  font-weight: ${({ theme, isSelected }) => (isSelected ? theme.fonts.weight.bolder : theme.fonts.weight.regular)};

  &&:hover {
    background-color: ${({ theme }) => theme.colors.background.tableRowHover};
    border-radius: ${({ theme }) => theme.radius.small};
  }
`;

export const StyledOptionName = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledIcon = styled(FontAwesomeIcon)`
  & {
    height: 1.8rem;
    width: 1.8rem;
    color: ${({ theme }) => theme.colors.text.main};
  }
`;

export const StyledOptionWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 0.8rem;
`;

export const StyledImg = styled.img`
  position: absolute;
  left: 0.3rem;
`;

export const StyledLine = styled.div`
  border: 0.1rem solid ${({ theme }) => theme.colors.background.grey};
  border-radius: 2rem;
  width: 100%;
  margin-bottom: ${({ theme }) => theme.radius.small};
`;

export const StyledResponsiveContainer = styled.div`
  display: none;
  flex-direction: column;
  align-items: center;
  margin-top: 1rem;
  margin-bottom: 1.6rem;
  padding-left: 3rem;
  width: 100%;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    display: flex;
  }
`;

export const StyledEllipsesIcon = styled(FontAwesomeIcon)`
  & {
    height: 2rem;
    width: 2rem;
    color: ${({ theme }) => theme.colors.text.main};
  }
`;

export const StyledChevronUp = styled(FontAwesomeIcon)`
  & {
    height: 1.6rem;
    width: 1.6rem;
    color: ${({ theme }) => theme.colors.grey[400]};
  }
`;

export const StyledBar = styled.div`
  background-color: ${({ theme }) => theme.colors.primary.main};
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 0.3rem;
  border-radius: 0.5rem 0 0 0.5rem;
`;
